// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro seal_Level.
 */
enum EnumSealLevel {
    QUALIFIED = 'QUALIFIED', 
    GUARANTEED = 'GUARANTEED'
};
export default EnumSealLevel;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumSealLevel.QUALIFIED]: {caption: ''},
    [EnumSealLevel.GUARANTEED]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
